import Vue from 'vue'
import Router from 'vue-router'

import VueConfig from '../vue.config.js';

// お問い合わせフォーム
import InquiryConfig from '../config/inquiry.js';
import InquiryForm from "../components/pages/inquiry/inquiry-form.vue";
import InquiryConfirm from "../components/pages/inquiry/inquiry-confirm.vue";
import InquiryComplete from "../components/pages/inquiry/inquiry-complete.vue";

// お申込みフォーム
import CharibonAttention from "../components/pages/buy/charibon-attention.vue";
import CharibonEntryForm from "../components/pages/buy/charibon-entry-form.vue";
import CharibonEntryConfirm from "../components/pages/buy/charibon-entry-confirm.vue";
import QuickEntryOtp from "../components/pages/buy/quick-entry-otp.vue";
import CharibonEntryComplete from "../components/pages/buy/charibon-entry-complete.vue";

// お申込み状況
import OfferInfoLogin from "../components/pages/buy/offer-info-login.vue";
import OfferInfoStatus from "../components/pages/buy/offer-info-status.vue";
import PickupInformationConfirm from "../components/organisms/buy/pickup-information-confirm.vue";
import PickupInformation from "../components/organisms/buy/pickup-information.vue";
import BuyStatus from "../components/organisms/buy/buy-status.vue";
import PickupPackagesConfirm from "../components/organisms/buy/pickup-packages-confirm.vue";
import PickupPackages from "../components/organisms/buy/pickup-packages.vue";
import ResultMessageCard from "../components/molecules/result-message-card.vue";

// メール配信解除
import Newsletter from "../components/organisms/newsletter/unsubscribe.vue";

Vue.use(Router);

// baseタグのSPAのルート定義 www.charibon.jp|chadev の場合、baseを /form/ とする
const url = location.href;
Vue.prototype.$routerBase = url.match(/www.charibon.jp|chadev|chastg|closedcharibon|chaprd/g) ? "/form/" : ""

export default new Router({
    mode: 'history',
    base: Vue.prototype.$routerBase,
    relative: true, // route baseを動的に変更する
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0};   // 常に最上部を表示
    },
    props: true,
    routes: [
        {
            path: '/charibon-inquiry',
            component: InquiryForm,
            name: 'InquiryForm',
            props: {inquiryTypes: InquiryConfig.inquiryTypes.charibon}
        },
        {
            path: '/charibon-inquiry/confirm',
            component: InquiryConfirm,
            name: 'InquiryConfirm',
            props: {
                inquiryTypes: InquiryConfig.inquiryTypes.charibon,
                subHeaderClass: 'border-grey',
            }
        },
        {
            path: '/charibon-inquiry/complete',
            component: InquiryComplete,
            name: 'InquiryComplete',
            props: {
                baseUrl: VueConfig.charibon_url,
                buttonLabel: 'チャリボントップへ',
            }
        },
        {
            path: '/charibon-offer',
            name: 'CharibonAttention',
            redirect: {
                name: 'CharibonEntryForm',
            },
        },
        {
            path: '/charibon-offer/form',
            component: CharibonEntryForm,
            name: 'CharibonEntryForm',
        },
        {
            path: '/charibon-offer/confirm',
            component: CharibonEntryConfirm,
            name: 'CharibonEntryConfirm'
        },
        {
            path: '/charibon-offer/authentication',
            component: QuickEntryOtp,
            name: 'QuickEntryOtp',
            props: {
                formPathName:'CharibonEntryForm',
                completePathName: 'CharibonEntryComplete'
            }
        },
        {
            path: '/charibon-offer/complete',
            component: CharibonEntryComplete,
            name: 'CharibonEntryComplete',
            props: true,
        },
        {
            path: '/charibon-status',
            component: OfferInfoLogin,
            name: 'OfferInfoLogin',
        },
        {
            path: '/charibon-status/',
            component: OfferInfoStatus,
            name: 'OfferInfoStatus',
            props: true,
            children: [
                {
                    path: 'state',
                    components: {
                        state: BuyStatus,
                    },
                    name: 'BuyStatus',
                },
                {
                    path: 'state/complete',
                    components: {
                        state: ResultMessageCard,
                    },
                    name: 'BuyStatusMessageCard',
                    props: { state: true }
                },
                {
                    path: 'address',
                    components: {
                        state: PickupInformationConfirm,
                    },
                    name: 'AddressReference'
                },
                {
                    path: 'address/form',
                    components: {
                        state: PickupInformation,
                    },
                    name: 'AddressForm'
                },
                {
                    path: 'address/confirm',
                    components: {
                        state: PickupInformationConfirm,
                    },
                    name: 'AddressConfirm'
                },
                {
                    path: 'address/complete',
                    components: {
                        state: ResultMessageCard,
                    },
                    name: 'AddressResultMessageCard',
                    props: { state: true }
                },
                {
                    path: 'pickup',
                    components: {
                        state: PickupPackagesConfirm,
                    },
                    name: 'PickupPackagesReference'
                },
                {
                    path: 'pickup/form',
                    components: {
                        state: PickupPackages,
                    },
                    name: 'PickupPackagesForm',
                    props: {state: true}
                },
                {
                    path: 'pickup/confirm',
                    components: {
                        state: PickupPackagesConfirm,
                    },
                    name: 'PickupPackagesConfirm'
                },
                {
                    path: 'pickup/complete',
                    components: {
                        state: ResultMessageCard,
                    },
                    name: 'PickupPackagesResultMessageCard',
                    props: { state: true }
                },
            ]
        },
        {
            path: '/charibon-newsletter/unsubscribe',
            component: Newsletter,
            name: 'Newsletter'
        },
    ]
})
